import { Icon } from "@iconify/react";
import eyeFill from "@iconify/icons-eva/eye-fill";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";
import shareFill from "@iconify/icons-eva/share-fill";
import messageCircleFill from "@iconify/icons-eva/message-circle-fill";
// material
import { alpha, styled } from "@mui/material/styles";
import {
  Box,
  Card,
  Grid,
  Avatar,
  Typography,
  CardContent,
} from "@mui/material";
// routes
// utils
import { fDate } from "../../utils/formatTime";
import { fShortenNumber } from "../../utils/formatNumber";
// @types
import { Post } from "../../types/blog";
//
import SvgIconStyle from "../SvgIconStyle";
import { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";

// ----------------------------------------------------------------------

const CardMediaStyle = styled("div")(({ theme }) => ({
  position: "relative",
  paddingTop: "calc(100% * 3 / 4)",
}));

const TitleStyle = styled(RouterLink)(({ theme }) => ({
  ...theme.typography.subtitle2,
  height: 40,
  color: "inherit",
  overflow: "hidden",
  WebkitLineClamp: 2,
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
  textDecoration: "none",
  "&:hover": {
    textDecoration: "underline",
  },
}));

const AvatarStyle = styled(Avatar)(({ theme }) => ({
  zIndex: 9,
  width: 32,
  height: 32,
  position: "absolute",
  left: theme.spacing(3),
  bottom: theme.spacing(-2),
}));

const InfoStyle = styled("div")(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "flex-end",
  marginTop: theme.spacing(3),
  color: theme.palette.text.disabled,
}));

const CoverImgStyle = styled("img")(({ theme }) => ({
  top: 0,
  width: "100%",
  height: "100%",
  objectFit: "cover",
  position: "absolute",
}));

// ----------------------------------------------------------------------

type BlogPostCardProps = {
  post: Post;
  index: number;
};

export default function BlogPostCard({ post, index }: BlogPostCardProps) {
  const { id, slug, cover, title, view, comment, share, author, createdAt } =
    post;
  const linkTo = `/blog/post/${slug}`;
  const latestPostLarge = index === 0;
  const latestPost = index === 1 || index === 2;
  const navigate = useNavigate();
  const POST_INFO = [
    { number: comment, icon: messageCircleFill },
    { number: view, icon: eyeFill },
    { number: share, icon: shareFill },
  ];

  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsAuthenticated(!!user); // true nếu user tồn tại, false nếu không
    });
    return () => unsubscribe(); // Cleanup
  }, [auth]);

  const editPost = () => {
    if (isAuthenticated) {
      localStorage.setItem(id, JSON.stringify(post));
      navigate(`/new-post/?id=${id}`);
    }
  };

  return (
    <Grid
      size={{
        xs: latestPostLarge ? 12 : 6,
        sm: latestPostLarge ? 12 : 6,
        md: latestPostLarge ? 6 : 3,
      }}
    >
      <Card sx={{ position: "relative" }}>
        <CardMediaStyle
          sx={{
            ...((latestPostLarge || latestPost) && {
              pt: "calc(100% * 4 / 3)",
              "&:after": {
                top: 0,
                content: "''",
                width: "100%",
                height: "100%",
                position: "absolute",
                // bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72),
              },
            }),
            ...(latestPostLarge && {
              pt: {
                xs: "calc(100% * 9 / 16 )",
                sm: "calc(100% * 3 / 4.66)",
              },
            }),
          }}
        >
          <SvgIconStyle
            color="paper"
            src="/static/icons/shape-avatar.svg"
            sx={{
              width: 80,
              height: 36,
              zIndex: 9,
              bottom: -15,
              position: "absolute",
              ...((latestPostLarge || latestPost) && { display: "none" }),
            }}
          />
          <AvatarStyle
            alt={author.name}
            // src={author.avatarUrl}
            src="https://firebasestorage.googleapis.com/v0/b/refrigeration-9e407.firebasestorage.app/o/avatar%2Favatar.webp?alt=media&token=ee0c08d9-8d64-4937-9e2d-6203c00c1c58"
            onClick={() => editPost()}
            sx={{
              ...((latestPostLarge || latestPost) && {
                zIndex: 9,
                top: 24,
                left: 24,
                width: 40,
                height: 40,
              }),
            }}
          />

          <CoverImgStyle alt={title} src={cover} />
        </CardMediaStyle>

        <CardContent
          sx={{
            ...((latestPostLarge || latestPost) && {
              bottom: 0,
              width: "100%",
              position: "absolute",
            }),
          }}
        >
          <Typography
            gutterBottom
            variant="caption"
            sx={{
              display: "block",
              backgroundColor: alpha("#fff", 0.6),
              p: 0.5,
              borderRadius: 1,
            }}
          >
            {fDate(createdAt)}
          </Typography>

          <TitleStyle
            to={linkTo}
            sx={{
              ...((latestPostLarge || latestPost) && {
                color: "common.white",
                backgroundColor: alpha("#000", 0.45),
                p: 1,
                borderRadius: 1,
                height: 55,
              }),
            }}
          >
            {title}
          </TitleStyle>

          {/* <InfoStyle>
            {POST_INFO.map((info, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  ml: index === 0 ? 0 : 1.5,
                  ...((latestPostLarge || latestPost) && {
                    color: "grey.500",
                  }),
                }}
              >
                <Box
                  component={Icon}
                  icon={info.icon}
                  sx={{ width: 16, height: 16, mr: 0.5 }}
                />
                <Typography variant="caption">
                  {fShortenNumber(info.number)}
                </Typography>
              </Box>
            ))}
          </InfoStyle> */}
        </CardContent>
      </Card>
    </Grid>
  );
}
